import React from "react";
import { useAppText } from "src/commun/composants/AppText";
import { useFormikContext } from "formik";
import AppInputPasswordFormik from "src/commun/composants/formulaire/formik/fields/AppInputPasswordFormik";
import AppInput from "src/commun/composants/formulaire/AppInput/AppInput";
import { Rattachement } from "src/pages/rattachement/form/useValidationSchemaRattachement";


const RattachementFormContent = () => {
  const { tString } = useAppText();
  const { values, submitCount, submitForm } = useFormikContext<Rattachement>();

  return (
    <>
      <div className="input btn__filter--disabled">
        <AppInput name="targetEmailAddress" value={values.targetEmailAddress} onChange={() => {}} disabled />
      </div>

      <AppInputPasswordFormik
        name="targetPassword"
        label={tString("compte.mon.profile.password")}
        formulaireSoumis={submitCount > 0}
      />

      <input
        className="btn__primary mt-3  btn--full--xs"
        type="submit"
        name="submit"
        onClick={submitForm}
        value={tString("global.valider")}
      />
    </>
  );
};

export default RattachementFormContent;